import React from 'react';
import styles from './EmptyState.module.css';

/** Estado vazio leve: ícone em círculo, título curto e uma linha de apoio. */
function EmptyState({ icon, title, text, tone = 'blue', compact = false, action = null }) {
    return (
        <div className={`${styles.empty} ${compact ? styles.compact : ''}`}>
            <div className={`${styles.iconWrap} ${styles[tone] || ''}`}>
                <span className={styles.halo} aria-hidden="true" />
                {icon}
            </div>
            <span className={styles.title}>{title}</span>
            {text && <span className={styles.text}>{text}</span>}
            {action && <div className={styles.action}>{action}</div>}
        </div>
    );
}

export default EmptyState;
